module.exports = window.urls;